<template>
  <div class="tw-px-12 tw-pb-12 tw-pt-5 tw-flex tw-flex-col tw-gap-8 tw-justify-center">
    <slot />
  </div>
</template>
